import exp from 'constants'

const TertiaryButton = ({
  children,
  onClick,
  linkUrl = '',
}: {
  children: React.ReactNode
  onClick?: () => void
  linkUrl?: string
}) => {
  if (linkUrl) {
    return (
      <a
        className="flex items-center gap-2 justify-center hover:text-old-primaryLight  transition-all ease-in-out text-old-primary"
        href={`https://${linkUrl}`}
        target="_blank"
      >
        {children}
      </a>
    )
  }
  return (
    <button
      className="flex items-center gap-2 justify-center hover:text-old-primaryLight  transition-all ease-in-out text-old-primary"
      onClick={onClick}
    >
      {children}
    </button>
  )
}

export default TertiaryButton
